import { ConsultantModel } from 'app/core/mips/common/models/consultant.model';

export interface UserState {
  currentUser: ConsultantModel | null;
}

export const initialUserState: UserState = {
  currentUser: null
};
  